 
import AppHeader from "../../components/app-header/app-header";
import Cards from "../../components/cards/cards";
import { bone } from "../../utils/bone";
import styles from "./palavrab.module.css";

function Palavrab() {
  
  
  return (
    <div className={styles.main}>
      <div className={styles.header}>
        <AppHeader name={"Учим слова B1"}></AppHeader>
      </div>
      <Cards list={bone}></Cards>
    </div>
  );
}

export default Palavrab;
